// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OJtYR","icon":"styles_icon__2-VAQ"};